import { Component, OnInit } from '@angular/core';
import { ContactModel } from '../Models/contact.model';
import { ContactService } from '../Services/contact.service';
import { SnotifyService, SnotifyToast, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

  model: ContactModel = new ContactModel();
  alertMessage = '';
  constructor(
    private contactService: ContactService,
    private snotifyService: SnotifyService
  ) { }

  ngOnInit() {
  }

  formSubmitted(){
    console.log('form submitted', this.model);
    if(this.model && this.model.name && this.model.email && this.model.subject && this.model.message){
      if(this.isValidEmail(this.model.email)){
        console.log('continue form submission');
        this.alertMessage = '';
        this.contactService.saveContactRequest(this.model).toPromise().then((res) => {
          console.log(res);
          this.snotifyService.success('Request sent successfully',  {position:SnotifyPosition.rightTop});
          this.resetContactForm();
        }).catch(err => {
          this.snotifyService.error('Failed to create a request', err,  {position:SnotifyPosition.rightTop});
        });
      }else{
        this.alertMessage = 'Please enter valid email';
      }
    }else{
      this.alertMessage = 'Please complete the form';
    }
  }

  resetContactForm(){
    this.model = new ContactModel();
  }

  isValidEmail( value ) {
    return /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,5}$/.test( value );
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-form/contact-form.component.ts